<template>
  <div class="c-config-content">
    <h4 class="c-config-content__title">{{ $t('ivr') }}</h4>
    <div>
      <div class="c-template-table table-responsive c-role-table">
        <table class="table table-hover">
          <thead>
          <tr style="background-color: #F1F5FB">
            <th>{{ $t('ivrName') }}</th>
            <th>{{ $t('ext') }}</th>
            <th></th>
          </tr>
          </thead>
          <tbody v-if="items.length">
          <tr v-for="item in items" :key="item._id">
            <td>{{ item.name }}</td>
            <td>{{ item.ext }}</td>
            <td class="text-right">
              <button @click="update(item._id)" class="btn btn-outline-gray btn-sm"
                      type="button">
                <font-awesome-icon icon="info"/>
              </button>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="3" class="text-center text-gray-999">{{ $t('noIVRFound') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="c-paging" v-if="itemCount > filterFormModel.pageSize">
        <b-pagination size="sm" class="pagination pagination-sm justify-content-center"
                      v-model="filterFormModel.page" :total-rows="itemCount"
                      :per-page="filterFormModel.pageSize" @input="load">
        </b-pagination>
      </div>
      <b-modal size="lg" v-model="showForm" :title="$t('ivrFormTitle')" @ok="save" no-close-on-backdrop
               no-enforce-focus>
        <div class="row">
          <div class="col-lg">
            <form-input :label="$t('ivrName')" :model="formModel" attribute="name" :errors="formErrors" :placeholder="$t('ivrName')"></form-input>
            <form-input :label="$t('ext')" :model="formModel" attribute="ext" :errors="formErrors" :placeholder="$t('ivrExtPlaceholder')"></form-input>
            <recording-select :client-id="client._id" :label="$t('ivrGreetRecording')" :model="formModel" attribute="greetRecording" :errors="formErrors"></recording-select>
            <form-input :label="$t('maxFailures')" :model="formModel" attribute="maxFailures" :errors="formErrors"></form-input>
            <recording-select :client-id="client._id" :label="$t('invalidRecording')" :model="formModel" attribute="invalidRecording" :errors="formErrors"></recording-select>
            <div v-if=formModel.maxFailures>
              <target-select :client-id="client._id" :label="$t('execOnMaxFailures')" :model="formModel" attribute="execOnMaxFailures" :errors="formErrors"></target-select>
            </div>
            <form-input :label="$t('maxTimeout')" :model="formModel" attribute="maxTimeout" :errors="formErrors"></form-input>
            <div v-if=formModel.maxTimeout>
              <target-select :client-id="client._id" :label="$t('execOnMaxTimeout')" :model="formModel" attribute="execOnMaxTimeout" :errors="formErrors"></target-select>
            </div>
            <recording-select :client-id="client._id" v-if="!formModel.execOnMaxTimeout" :label="$t('timeoutRecording')" :model="formModel" attribute="timeoutRecording" :errors="formErrors"></recording-select>
            <form-checkbox :chk-label="$t('directDial')" :model="formModel" attribute="directDial" :errors="formErrors"></form-checkbox>
          </div>
          <div class="col-lg">
            <target-select :client-id="client._id" :model="formModel" attribute="target1" :label="$t('keyPress',['1'])" :errors="formErrors"></target-select>
            <target-select :client-id="client._id" :model="formModel" attribute="target2" :label="$t('keyPress',['2'])" :errors="formErrors"></target-select>
            <target-select :client-id="client._id" :model="formModel" attribute="target3" :label="$t('keyPress',['3'])" :errors="formErrors"></target-select>
            <target-select :client-id="client._id" :model="formModel" attribute="target4" :label="$t('keyPress',['4'])" :errors="formErrors"></target-select>
            <target-select :client-id="client._id" :model="formModel" attribute="target5" :label="$t('keyPress',['5'])" :errors="formErrors"></target-select>
            <target-select :client-id="client._id" :model="formModel" attribute="target6" :label="$t('keyPress',['6'])" :errors="formErrors"></target-select>
            <target-select :client-id="client._id" :model="formModel" attribute="target7" :label="$t('keyPress',['7'])" :errors="formErrors"></target-select>
            <target-select :client-id="client._id" :model="formModel" attribute="target8" :label="$t('keyPress',['8'])" :errors="formErrors"></target-select>
            <target-select :client-id="client._id" :model="formModel" attribute="target9" :label="$t('keyPress',['9'])" :errors="formErrors"></target-select>
            <target-select :client-id="client._id" :model="formModel" attribute="target0" :label="$t('keyPress',['0'])" :errors="formErrors"></target-select>
          </div>
        </div>
        <template v-slot:modal-footer>
          <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('close') }}
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import list from '@/mixins/List';
import crud from '@/mixins/CRUD';
import RecordingSelect from "@/components/ClientRecordingSelect.vue";
import TargetSelect from "@/components/ClientTargetSelect.vue";

export default {
  mixins: [list, crud],
  props: ['client'],
  components: {RecordingSelect, TargetSelect},
  data: function () {
    return {
      service: '/ivr',
      autoLoad: true,
      defaultFormModel: {
        maxFailures: 3,
        maxTimeout: 15,
        execOnMaxTimeout: null
      },
      defaultFilterFormModel: {
        client: this.client._id
      }
    }
  },
  i18n: {
    messages: {
      vi: {
        ivr: "Trả lời tự động (IVR)",
        ivrName: "Tên IVR",
        ivrFormTitle: "Thông tin IVR",
        ivrGreetRecording: "File ghi âm lời chào",
        maxFailures: "Số lần bấm sai tối đa",
        invalidRecording: "File ghi âm khi bấm sai phím",
        execOnMaxFailures: "Hành động khi đạt số lần bấm sai tối đa (kết thúc cuộc gọi nếu không chọn)",
        maxTimeout: "Thời gian chờ tối đa (giây)",
        execOnMaxTimeout: "Hành động khi hết thời gian chờ (kết thúc cuộc gọi nếu không chọn)",
        timeoutRecording: "File ghi âm khi hết thời gian chờ mà không có hành động kế tiếp",
        directDial: "Cho phép quay trực tiếp số nhánh",
        keyPress: "Phím bấm {0}",
        close: "Đóng",
        noIVRFound: "Chưa có IVR nào được thiết lập",
      },
      en: {
        ivr: "Trả lời tự động (IVR)",
        ivrName: "Tên IVR",
        ivrFormTitle: "Thông tin IVR",
        ivrGreetRecording: "File ghi âm lời chào",
        maxFailures: "Số lần bấm sai tối đa",
        invalidRecording: "File ghi âm khi bấm sai phím",
        execOnMaxFailures: "Hành động khi đạt số lần bấm sai tối đa (kết thúc cuộc gọi nếu không chọn)",
        maxTimeout: "Thời gian chờ tối đa (giây)",
        execOnMaxTimeout: "Hành động khi hết thời gian chờ (kết thúc cuộc gọi nếu không chọn)",
        timeoutRecording: "File ghi âm khi hết thời gian chờ mà không có hành động kế tiếp",
        directDial: "Cho phép quay trực tiếp số nhánh",
        keyPress: "Phím bấm {0}",
        close: "Đóng",
        noIVRFound: "Chưa có IVR nào được thiết lập",
      }
    }
  }

}
</script>